import { Button, ButtonGroup } from "react-bootstrap";

import React from 'react';

const Row = ({ link, onRemove, onUpdate}) => {
    return (
        <tr>
            <td style={{ textAlign: 'left' }}>{link.type}</td>
            <td>{link.link}</td>
            <td>{link.platform}</td>
            <td>
                <ButtonGroup>
                    <Button bsStyle="info" onClick={() => onUpdate(link)}>Update</Button>
                    <Button bsStyle="danger" onClick={() => onRemove(link.type)}>Remove</Button>
                </ButtonGroup>
            </td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkLinks/components/Table/components/Row/index.js